/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown, X } from "__barrel_optimize__?names=ChevronDown,X!=!lucide-react";
import { clearValue } from "@/components/select/helpers";
export default function Adornment(param) {
    let { clearable, onChange, value } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: 'flex gap-1',
        children: [
            clearable && value && /*#__PURE__*/ _jsx(X, {
                size: 15,
                className: 'cursor-pointer pointer-events-auto',
                onClick: (event)=>clearValue(event, onChange)
            }),
            /*#__PURE__*/ _jsx(ChevronDown, {
                size: 15
            })
        ]
    });
}
